import React from 'react';
import './About.css';

const About = () => {
  return (
    <div 
      className="about wow fadeInUp" 
      data-wow-delay="0.1s"
      style={{
        backgroundImage: "url('/img/Aboutus_New.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative'
      }}
    >
      <div className="overlay"></div>
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="row about-row">
          <div className="col-lg-5 p-0">
            <div className="about-img">
              <img src="/img/Aboutus_New.png" alt="About Mikan" />
            </div>
          </div>
          <div className="col-lg-7 p-0">
            <div className="about-content">
              <div className="section-header text-left">
                <h2 style={{ color: '#0e0d0b' }}>About Our Company</h2>
              </div>
              <div className="about-text text-justify">
                <p>
                  Mikan Group is an engineering consultancy and BIM firm specializing in engineering
                  equipment and structural solutions. With a strong presence in India, Singapore, and
                  Europe, supported by a dedicated team of highly skilled engineers and technicians
                  with over 25 years of collective experience, the company is renowned for its
                  expertise in engineering consultancy, BIM consultancy, and outsourcing services. We
                  collaborate with consulting engineers, architects, and contractors on various
                  projects, from small-scale initiatives to large-scale endeavours, and specialize in
                  providing engineering equipment and structural solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;